"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shouldSkipClipResize;
var MINIMUM_CLIP_DURATION = 1;

function shouldSkipStartResize(_ref) {
  var clip = _ref.clip,
      resizeTime = _ref.resizeTime;
  var clipStartTime = clip.clipStartTime,
      startTime = clip.startTime,
      duration = clip.duration;
  var clipAlreadyResized = Boolean(clipStartTime);
  var isNegativeResize = resizeTime < startTime;
  var isResizedSmallerThanMinimum = resizeTime >= startTime + duration - MINIMUM_CLIP_DURATION;

  if (isResizedSmallerThanMinimum || isNegativeResize && !clipAlreadyResized) {
    return true;
  }

  if (!clipAlreadyResized || !isNegativeResize) {
    return false;
  }

  var negativeResizeAmount = Math.abs(startTime - resizeTime);
  var isResizedPastMaximum = negativeResizeAmount > clipStartTime;
  return isResizedPastMaximum;
}

function shouldSkipEndResize(_ref2) {
  var clip = _ref2.clip,
      resizeTime = _ref2.resizeTime;
  var isImage = clip.isImage,
      originalDuration = clip.originalDuration,
      clipStartTime = clip.clipStartTime,
      startTime = clip.startTime;

  if (isImage) {
    return false;
  }

  var isResizedSmallerThanMinimum = resizeTime <= startTime + MINIMUM_CLIP_DURATION;
  var isResizedPastMaximum = resizeTime > startTime + originalDuration - clipStartTime;
  return isResizedSmallerThanMinimum || isResizedPastMaximum;
}

function shouldSkipClipResize(_ref3) {
  var isStartResize = _ref3.isStartResize,
      clip = _ref3.clip,
      resizeTime = _ref3.resizeTime;
  var action = isStartResize ? shouldSkipStartResize : shouldSkipEndResize;
  return action({
    clip: clip,
    resizeTime: resizeTime
  });
}